import { useAuth } from "react-oidc-context";
import { listItemIconClasses, MenuItem, Button } from "@mui/material";
import { COGNITO_CLIENT_ID, COGNITO_LOGOUT_URI, COGNITO_DOMAIN } from "../../utils/config";

const CognitoSignOutButton = () => {
    const auth = useAuth();

    const handleSignout = () => {
        const clientId = COGNITO_CLIENT_ID;
        const logoutUri = COGNITO_LOGOUT_URI;
        const cognitoDomain = COGNITO_DOMAIN;
        auth.removeUser();
        window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
    }

    return (
        <MenuItem sx={{
            [`& .${listItemIconClasses.root}`]: {
                ml: 'auto',
                minWidth: 0,
            },
        }}>
            <Button
                onClick={handleSignout}
                sx={{
                    borderWidth: '2px',
                    color: '#00081C',
                    borderColor: '#00081C',
                    backgroundColor: '#ffffff',
                    fontSize: '18px',
                    fontFamily: 'New Transport',
                    fontWeight: 700,
                    height: '48px',
                    width: '100%'
                }}
            >Log out&nbsp;&nbsp;</Button>

        </MenuItem>
    );
};

export default CognitoSignOutButton;
